import PropTypes from 'prop-types';

export const AssetPropType = {
  assetUrl: PropTypes.string,
  assetAlt: PropTypes.string,
};
